import { properties } from '../properties';
import apiFetch from '../auth/apiFetch';

export const getAffiliatesByJkaId = async (jkaId) => {
    try {
        const response = await apiFetch(`${properties.baseURL}/affiliates/jkaid/${jkaId}`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error("Error fetching affiliates by JKA ID:", error);
        return [];
    }
};

function getTeachers() {
    return apiFetch(properties.baseURL + properties.teachersPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getTeachersSummary() {
    return apiFetch(properties.baseURL + properties.teachersSummaryPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getAffiliates() {
    return apiFetch(properties.baseURL + properties.affiliatesPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getAffiliatesSummary() {
    return apiFetch(properties.baseURL + properties.affiliatesSummaryPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getActiveAffiliates() {
    return apiFetch(properties.baseURL + properties.activeAffiliatePath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getActiveAssociateAffiliates() {
    return apiFetch(properties.baseURL + properties.activeAssociateAffiliatePath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getBlackBelts() {
    return apiFetch(properties.baseURL + properties.blackBeltsPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getBlackBeltsSummary() {
    return apiFetch(properties.baseURL + properties.blackBeltsSummaryPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getBlackBeltsSummaryOrderByName() {
    return apiFetch(properties.baseURL + properties.blackBeltsSummaryOrderByNamePath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getShihankaiMembers() {
    return apiFetch(properties.baseURL + properties.shihankaiMembersPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getGyms() {
    return apiFetch(properties.baseURL + properties.gymsPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getGymsAffiliate() {
    return apiFetch(properties.baseURL + properties.gymsAffiliatePath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getGymsNotAffiliate() {
    return apiFetch(properties.baseURL + properties.gymsNotAffiliatePath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getInstructors() {
    return apiFetch(properties.baseURL + properties.instructorsPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getExaminers() {
    return apiFetch(properties.baseURL + properties.examinersPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getJudges() {
    return apiFetch(properties.baseURL + properties.judgesPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getAffiliatesByState(id) {
    return apiFetch(properties.baseURL + properties.affiliatesByStatePath + '/' + id)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getAffiliatesByName(name) {
    return apiFetch(properties.baseURL + properties.affiliatesByNamePath + '/' + name)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getBlackBeltByName(name) {
    return apiFetch(properties.baseURL + properties.blackbeltsByNamePath + '/' + name)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getBlackBeltState(id) {
    return apiFetch(properties.baseURL + properties.blackbeltsStatePath + '/' + id)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getGymsState(id) {
    return apiFetch(properties.baseURL + properties.gymsStatePath + '/' + id)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getJudgesMaps() {
    return apiFetch(properties.baseURL + properties.judgesMapsPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getGymsName() {
    return apiFetch(properties.baseURL + properties.gymsNamePath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getGymResponsibles() {
    return apiFetch(properties.baseURL + properties.gymResponsiblesPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getCourses() {
    return apiFetch(properties.baseURL + properties.coursesPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getDojosNames() {
    return apiFetch(properties.baseURL + properties.gymNameIdPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getGrades() {
    return apiFetch(properties.baseURL + properties.gradesPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getStates() {
    return apiFetch(properties.baseURL + properties.statesPath)
        .then(res => res.json())
        .then(r => JSON.parse('{ "data": ' + JSON.stringify(r) + '}'))
        .then(d => d.data);
}

function getDashboard() {
    return apiFetch(properties.baseURL + '/dashboard')
        .then(res => res.json());
}

async function postCourse2(course, file) {
    try {
        const formData = new FormData();
        formData.append('course', new Blob([JSON.stringify(course)], { type: 'application/json' }));
        if (file) {
            formData.append('file', file);
        }
        const res = await apiFetch(properties.baseURL + properties.coursesPath, {
            method: 'POST',
            body: formData,
        });
        if (!res.ok) {
            const message = `An error has occured: ${res.status} - ${res.statusText}`;
            throw new Error(message);
        }
        return await res.json();
    } catch (err) {
        console.log(err.message);
    }
}

async function postData(affiliate) {
    try {
        const res = await apiFetch(properties.baseURL + properties.affiliatesPath, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(affiliate),
        });
        if (!res.ok) {
            const message = `An error has occured: ${res.status} - ${res.statusText}`;
            throw new Error(message);
        }
        const data = await res.json();
        const result = {
            status: res.status + '-' + res.statusText,
            headers: {
                'Content-Type': res.headers.get('Content-Type'),
                'Content-Length': res.headers.get('Content-Length'),
            },
            data: data,
        };
        console.log(result);
    } catch (err) {
        console.log(err.message);
    }
}

export {
    getJudges, getJudgesMaps, getExaminers, getInstructors,
    getAffiliatesByName, getAffiliatesSummary, getBlackBeltByName,
    getAffiliatesByState, getBlackBeltState, getActiveAffiliates,
    getActiveAssociateAffiliates, getShihankaiMembers, getBlackBelts,
    getBlackBeltsSummary, getBlackBeltsSummaryOrderByName,
    getGymsAffiliate, getGymsNotAffiliate, getAffiliates,
    getTeachersSummary, getDojosNames, getGrades, getGyms,
    getGymsState, getGymsName, getCourses, getTeachers,
    getStates, getGymResponsibles, postData, postCourse2, getDashboard,
};
